import { Command } from 'commands/Commands';

export class ChangeArticleAuthor extends Command {
  type: string = 'BlogArticle.ChangeAuthor';
  constructor(id: string, newValue: string) {
    super(newValue, id);
  }
  priority: number = 100;
}
